__turbopack_context__.v({
  "errorMessageStyles": "planselector-module-scss-module__05HJ9q__errorMessageStyles",
  "headlineStyles": "planselector-module-scss-module__05HJ9q__headlineStyles",
  "inputStyles": "planselector-module-scss-module__05HJ9q__inputStyles",
  "inputWrapper": "planselector-module-scss-module__05HJ9q__inputWrapper",
  "mainWrapper": "planselector-module-scss-module__05HJ9q__mainWrapper",
  "offerDetailStyles": "planselector-module-scss-module__05HJ9q__offerDetailStyles",
  "offerPriceStyles": "planselector-module-scss-module__05HJ9q__offerPriceStyles",
  "offerSection": "planselector-module-scss-module__05HJ9q__offerSection",
  "offerTitleStyles": "planselector-module-scss-module__05HJ9q__offerTitleStyles",
  "planCardWrapper": "planselector-module-scss-module__05HJ9q__planCardWrapper",
  "selectButtonStyles": "planselector-module-scss-module__05HJ9q__selectButtonStyles",
  "selectorWrapper": "planselector-module-scss-module__05HJ9q__selectorWrapper",
  "textContentWrapper": "planselector-module-scss-module__05HJ9q__textContentWrapper",
  "textLinkStyles": "planselector-module-scss-module__05HJ9q__textLinkStyles",
});
